"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = require("swiper");
var modules_1 = require("swiper/modules");
document.addEventListener('alpine:init', function () {
    var swiper;
    Alpine.data('food', function () {
        return {
            init: function () {
                this.initGallery();
            },
            initGallery: function () {
                swiper = new swiper_1.default(this.$refs.gallery, {
                    modules: [modules_1.A11y, modules_1.Navigation],
                    loop: true,
                    speed: 500,
                    spaceBetween: 20,
                    slidesPerView: 1,
                    navigation: {
                        prevEl: this.$refs.prev || undefined,
                        nextEl: this.$refs.next || undefined,
                    },
                });
            },
        };
    });
});
